import { colors } from "../../../styles/figmaColors";
import { useTranslation } from "react-i18next";
import { Tag } from "../Tag/Tag";
import { ChevronRightOutlined } from "../../materialUi/materialUi";
import "../../../../i18n/i18n";

type Status =
  | "ACCEPTED"
  | "REJECTED"
  | "SUSPICIOUS"
  | "PENDING"
  | "CANCELED"
  | "REFUND";
const statusEnum = [
  "ACCEPTED",
  "REJECTED",
  "SUSPICIOUS",
  "PENDING",
  "CANCELED",
  "REFUND",
];
const statusProps = {
  ACCEPTED: {
    backgroundColor: colors["colors/system/success/success_ultraLight"],
    textColor: colors["colors/system/success/success_normal"],
    text: "accepted",
  },
  REJECTED: {
    backgroundColor: colors["colors/system/error/error_ultraLight"],
    textColor: colors["colors/system/error/error_normal"],
    text: "rejected",
    iconRight: <ChevronRightOutlined />,
  },
  SUSPICIOUS: {
    backgroundColor: colors["colors/surfaces/background/background_level2"],
    textColor: colors["colors/text/black"],
    text: "suspicious",
  },
  NO_SUPPORTING_DOCUMENT: {
    backgroundColor: colors["colors/surfaces/background/background_level2"],
    textColor: colors["colors/text/black"],
    text: "noSupportingDocument",
    colorHover: colors["colors/surfaces/background/background_level0"],
  },
  PENDING: {
    backgroundColor: colors["colors/surfaces/background/background_level2"],
    textColor: colors["colors/text/black"],
    text: "pending",
    colorHover: colors["colors/surfaces/background/background_level0"],
  },
  CANCELED: {
    backgroundColor: colors["colors/system/error/error_ultraLight"],
    textColor: colors["colors/system/error/error_normal"],
    text: "canceled",
  },
  REFUND: {
    backgroundColor: colors["colors/system/success/success_ultraLight"],
    textColor: colors["colors/system/success/success_normal"],
    text: "refund",
  },
};

type CategoryTagProps = {
  status: string;
  isRowHover?: boolean;
};

type StatusArgs = {
  backgroundColor: string;
  textColor: string;
  text: string;
  colorHover?: string;
  iconRight?: JSX.Element;
};

export const TableTagTransaction = (props: CategoryTagProps) => {
  const { t } = useTranslation();
  const statusTranslated = statusEnum.find(
    (s) => t(`transactions.status.${s}`) === props.status,
  );
  if (!statusTranslated) {
    return "";
  }

  const transactionStatus: StatusArgs = statusProps[statusTranslated as Status];

  return (
    <Tag
      text={props.status}
      backgroundColor={transactionStatus.backgroundColor}
      textColor={transactionStatus.textColor}
      colorHover={
        (props.isRowHover && transactionStatus.colorHover) || undefined
      }
      iconRight={transactionStatus.iconRight}
      iconColor={transactionStatus.textColor}
    />
  );
};
